export default {
  others: 'others'
}
